import { useAuthStore } from '@/stores/authStore'
import { usePermission } from '@/hooks/usePermission'
import { isPlanLapsed, lapsedReason } from '@/lib/planLapse'

/**
 * The account's lapsed-plan state for the current user: whether the plan has
 * run out, whether THIS user can renew it, and the tooltip to put on a control
 * that is disabled because of it.
 *
 * @example
 *   const { lapsed, reason } = usePlanLapse()
 *   <Button disabled={lapsed || busy} title={reason}>Launch</Button>
 */
export function usePlanLapse(): { lapsed: boolean; canRenew: boolean; reason: string | undefined } {
  const planStatus = useAuthStore((s) => s.planStatus)
  const { allowed: canRenew } = usePermission('billing', 'manage_subscription')
  const lapsed = isPlanLapsed(planStatus)
  return { lapsed, canRenew, reason: lapsed ? lapsedReason(canRenew) : undefined }
}
